// Accessor and Setter are local type stubs until solid-js dependency is available or types are migrated to React.
type Accessor<T> = () => T;
type Setter<T> = (value: T) => void;
type SetStoreFunction<T> = (value: Partial<T>) => void;
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export interface MTFStocksResponseData {
  exchId_symbol: string;
  exchange: number | string;
  token: number;
  nseToken: number;
  bseToken: number;
  symbol: string;
  fullName: string;
  ltp: number;
  prevClose: number;
  logo: string;
  sector: string;
  industry: string;
  mktCapType: string;
  mktCap: number;
  isin: string;
  timeStamp: string;
  formattedSymbol: string;
  listingStatus: string;
  tradeable: boolean;
  updateTimestamp: string;
  changePrice: string;
  perChange: string;
  stockStatus: string;
  redirectURL: string;
  perFunding: number;
}

export interface MTFResponseData {
  mtfList: MTFStocksResponseData[];
  showMore: boolean;
  showLess: boolean;
}

export const fetchMTFStocks = async (
  searchString: Accessor<string>,
  page?: number,
  limit?: number
) => {
  const response = await request<MTFResponseData>({
    method: "POST",
    url: API_PATHS.mtf,
    data: {
      searchString: searchString() ?? "",
      page: page ?? 1,
      limit: limit ?? 10,
    },
  });
  return response?.data;
};
